import React from "react";
import { RouterProvider } from "react-router-dom";
import IntlProvider from "./locales/IntlProvider";
import router from "./App";

const Root: React.FC = () => (
  <React.StrictMode>
    <IntlProvider>
      <RouterProvider router={router} />
    </IntlProvider>
  </React.StrictMode>
);

export default Root;
